import {useMutation} from "@tanstack/react-query";
import {apiPostUserReport} from "../../../../../data/api/userReport";

export const usePostUserReport = () => {
    return useMutation({
        mutationFn: (data) => apiPostUserReport(data)
    })
}